function Hero() {
  return (
    <section className="hero" id="home">
        <div className="hero-slides" id="heroSlides">
            <a href="https://wa.me/5519978291299" target="_blank" rel="noreferrer">
              <div className="slide active"><img src="images/banner1.jpg" alt="Banner 1" /></div>
            </a>
            <a href="https://wa.me/5519978291299" target="_blank" rel="noreferrer">
              <div className="slide"><img src="images/banner2.jpg" alt="Banner 2" /></div>
            </a>
        </div>
    </section>
  );
}

export default Hero;
